/**
 * Scales a recipe's ingredient amounts by a servings count.
 *
 * The server renders every amount at one serving and each row carries its own base figure in
 * `data-servings-amount`, so the list is already a correct recipe for one before this runs —
 * the buttons are an addition, not the mechanism.
 *
 * Amounts are rounded up rather than shown to a decimal: "13 ml" is a thing a person can pour,
 * "12.5 ml" is not. The base figure is never overwritten, so 3 servings is always 3x the
 * original and not 1.5x rounded twice.
 */
const MAX_SERVINGS = 12;

class FilliersServings extends HTMLElement {
  connectedCallback() {
    this.value = this.querySelector('[data-servings-value]');
    this.down = this.querySelector('[data-servings-down]');
    this.up = this.querySelector('[data-servings-up]');
    this.amounts = Array.from(this.querySelectorAll('[data-servings-amount]'));
    if (!this.value || !this.amounts.length) return;

    this.servings = 1;
    this.down?.addEventListener('click', () => this.set(this.servings - 1));
    this.up?.addEventListener('click', () => this.set(this.servings + 1));
    this.render();
  }

  set(next) {
    this.servings = Math.min(MAX_SERVINGS, Math.max(1, next));
    this.render();
  }

  render() {
    this.value.textContent = this.servings;
    // Disabled rather than hidden: unlike the carousel chips, these two are a pair and a gap
    // where one of them was would read as a rendering fault.
    if (this.down) this.down.disabled = this.servings <= 1;
    if (this.up) this.up.disabled = this.servings >= MAX_SERVINGS;

    this.amounts.forEach((el) => {
      const base = parseFloat(el.dataset.servingsAmount);
      if (Number.isNaN(base)) return;
      const unit = el.dataset.servingsUnit || '';
      el.textContent = `${Math.ceil(base * this.servings)} ${unit}`.trim();
    });
  }
}

if (!customElements.get('filliers-servings')) {
  customElements.define('filliers-servings', FilliersServings);
}
